import * as React from "react";
import { IconProps } from "./IconProps";

export const IconCheckmark = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5905 0.192942C20.0362 0.519046 20.1332 1.14474 19.8071 1.59047L8.10119 17.5905C7.94053 17.8101 7.69731 17.9547 7.42765 17.9911C7.15799 18.0274 6.88517 17.9523 6.67211 17.783L0.377994 12.783C-0.0544479 12.4395 -0.126526 11.8104 0.217002 11.378C0.560531 10.9456 1.18958 10.8735 1.62202 11.217L7.10143 15.5698L18.1929 0.409544C18.519 -0.0361852 19.1447 -0.133161 19.5905 0.192942Z"
          fill={color}
        />
      </svg>
    );
  },
);
